/* import __COLOCATED_TEMPLATE__ from './bottom-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();